type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
  isNumeric?: boolean;
};

export const RecordReviewerHeader: Header[] = [

  {
    key: "patientName",
    label: "Patient Name",
    style: { width: "240px" },
    sortable: true,
  },
  {
    key: "qmeDoctorName",
    label: "Doctor",
    style: { width: "20%" },
    sortable: true,
  },
  {
    key: "record_Received",
    label: "Records Recieved",
    style: { width: "15%" },
    sortable: true,
  },
  {
    key: "noOfPagesOfRecs",
    label: "No. of Pages",
    style: { width: "15%" },
    sortable: true,
  },
  {
    key: "rorDueDateDesc",
    label: "Due Date",
    style: { width: "15%" },
    sortable: true,
  },
  {
    key: "rorStatus",
    label: "ROR Status",
    style: { width: "20%" },
    sortable: true,
  },

  {
    key: "rorDocumentInfo",
    label: "ROR Document",
    style: { width: "20%" },
    sortable: true,
  },
  {
    key: "pagesReviewedCount",
    label: "Pages Reviewed",
    style: { width: "15%" },
    sortable: true,
  },
  {
    key: "ror_UploadedDate",
    label: "ROR Uploaded Date",
    style: { width: "20%" },
    sortable: true,
  },
  {
    key: "assignedToUserName",
    label: "ROR Assigned",
    style: { width: "20%" },
  },
  {
    key: "appointment_Date",
    label: "Appointment Date & Time",
    style: { width: "20%" },
    sortable: true,
  },
{
    key: "locationofAppointment",
    label: "Location",
    style: { width: "250px" },
    sortable: true,
  },
  {
    key: "appointmentStatus",
    label: "Appointment Status",
    style: { width: "20%" },
    sortable: true,
  },
  {
    key: "caseOrExamType",
    label: "Case / Exam Type",
    style: { width: "25%" },
    sortable: true,
  },
  {
    key: "caseId",
    label: "Case ID ",
    style: { width: "20%" },
    sortable: true,
  },
  
];

export const REVIEW_RECORD_HEADERS: Header[] = [
  {
    key: "documentTypeName",
    label: "Document Type",
    sortable: false,
    style: { width: "20%" },
  },
  {
    key: "documentCategory",
    label: "Document Category",
    sortable: false,
    style: { width: "23%" },
  },
  {
    key: "uploadedByName",
    label: "Uploaded By",
    sortable: false,
    style: { width: "12%" },
  },
  {
    key: "uploadDateTimeNew",
    label: "Uploaded On",
    sortable: false,
    style: { width: "14%" },
  },
  {
    key: "fileName",
    label: "File Name",
    sortable: false,
    style: { width: "15%" },
  },
  {
    key: "noOfPages",
    label: "Pages",
    sortable: false,
    style: { width: "10%" },
    isNumeric: true,
  },
  {
    key: "downloadROR",
    label: "Action",
    style: { width: "10%" },
  },
  {
    key: "pagesReviewed",
    label: "Pages Reviewed",
    style: { width: "15%" },
  },
];

export const REVIEW_HISTORY_HEADERS: Header[] = [
  {
    key: "rorStatusName",
    label: "ROR Status",
  },
  {
    key: "rorAssignedUserName",
    label: "Reviewer Name",
  },
  {
    key: "createdDateNew",
    label: "When",
  },
  {
    key: "elapsedDuration",
    label: "Elapsed Time",
  },
  {
    key: "toTalPagesReceived",
    label: "Pages Received",
    isNumeric: true,
  },
  {
    key: "totalPagesReviewed",
    label: "Pages Reviewed",
    isNumeric: true,
  },
  {
    key: "rorComments",
    label: "Comments",
  },
];
